import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flu',
  standalone: false
})
export class FirstLetterUppercasePipe implements PipeTransform {

  transform(value: string): unknown {
    return value.charAt(0).toUpperCase().concat(value.substring(1));
  }

}
